import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-empty-page',
  templateUrl: './empty-page.component.html',
  styleUrls: ['./empty-page.component.scss']
})
export class EmptyPageComponent {
  @Input() image: string = ''
  @Input() message: string = ''
  @Input() buttonText: string = ''
  @Input() link: string = ''

}
